import React, { Component } from 'react'
import { connect } from 'react-redux'

import { route } from 'selectors/common'

let select = (state) => ({
	screenSize: state.screenSize
  , route: route(state)
})

let widthOfColumns = (widthOfScreen, count, detailID) => {
	// if (widthOfScreen <= 900 && detailID){
	// 	return{menu: 0, left: 0, list: 0, right: widthOfScreen, count:1}
	// }
	if (widthOfScreen > 800 && widthOfScreen <= 1300) count=2
	if (!detailID) count=0
	let menu = 0 //55
	let left = widthOfScreen/(count+1)
	if (count == 1 && widthOfScreen > 1100) left = widthOfScreen - (widthOfScreen*1/3>500?widthOfScreen*1/3:500)
	let list = left-menu
	let right = widthOfScreen-left
	return{menu:0, left, list, right, count}
}

export class MasterDetailLayout extends Component {
	render() {
		let { props } = this
		let width = widthOfColumns(props.screenSize, props.detailColumns, props.detailOpen)
		return(
			<div>
				{props.header({width: "100%"})}
				<div className="layout horizontal">
					{width.left>0 && <div className="layout vertical" style={{width:width.left+"px"}}>
						<div className="layout horizontal">
							{width.list && props.master({width:width.list, masterDetail: props.detailOpen, detailID: props.detailID})}
						</div>
					</div>}
					{props.detailOpen &&
						<div style={{width:width.right-5+"px", margin: "0", boxShadow: "rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px", position: "relative"}}>
						 	{props.detail({width:width.right+"px", colspan: width.count, masterDetail: (width.list>0)})}
						</div>
					}
				</div>
			</div>
		)
	}
}

export default connect(select)(MasterDetailLayout)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/MasterDetailLayout.js